import { render, staticRenderFns } from "./AdminKlasses.vue?vue&type=template&id=6f4cdcc1&scoped=true"
import script from "./AdminKlasses.vue?vue&type=script&lang=js"
export * from "./AdminKlasses.vue?vue&type=script&lang=js"
import style0 from "./AdminKlasses.vue?vue&type=style&index=0&id=6f4cdcc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4cdcc1",
  null
  
)

export default component.exports